import React from 'react';
import { Card, Typography, Box } from 'vindi-ds-components';
import token from 'vindi-ds-tokens';
import SimplePricing from './simple_pricing';
import AdvancePricing from './advance_pricing';
import ProductDescription from './product_description';

function Pricing({ product }) {
  const schemaType = product.pricing_schema.schema_type;

  return (
    <Box mb={token.spacing.small.value}>
      <Card padding='xs'>
        <Typography variant='subtitle1' component='h3'>
          Dados do Produto
        </Typography>
      </Card>
      <Card padding='xs'>
        { ['flat', 'per_unit'].includes(schemaType) && <SimplePricing pricingSchema={product.pricing_schema} unit={product.unit} /> }
        { ['step_usage', 'volume_usage', 'tier_usage'].includes(schemaType) && <AdvancePricing pricingSchema={product.pricing_schema} unit={product.unit} /> }
        { product.description && <ProductDescription description={product.description} /> }
      </Card>
    </Box>
  );
}

export default Pricing;
